"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskRunnerErrorCode = void 0;
var TaskRunnerErrorCode;
(function (TaskRunnerErrorCode) {
    TaskRunnerErrorCode["MaxSizeExceeded"] = "MaxSizeExceeded";
    TaskRunnerErrorCode["SerializationFailed"] = "SerializationFailed";
    TaskRunnerErrorCode["InvalidArguments"] = "InvalidArguments";
    TaskRunnerErrorCode["InvalidTasksScript"] = "InvalidTasksScript";
    TaskRunnerErrorCode["TaskMissingFromScript"] = "TaskMissingFromScript";
    TaskRunnerErrorCode["InvalidTaskRunnerRequest"] = "InvalidTaskRunnerRequest";
    TaskRunnerErrorCode["TaskRunnerInternalError"] = "TaskRunnerInternalError";
    TaskRunnerErrorCode["TaskAlreadyExpired"] = "TaskAlreadyExpired";
    TaskRunnerErrorCode["RuntimeErrorInBehavior"] = "RuntimeErrorInBehavior";
    TaskRunnerErrorCode["RuntimeErrorInTask"] = "RuntimeErrorInTask";
    TaskRunnerErrorCode["ChaiAssertionError"] = "ChaiAssertionError";
})(TaskRunnerErrorCode = exports.TaskRunnerErrorCode || (exports.TaskRunnerErrorCode = {}));
//# sourceMappingURL=task-runner-error-codes.js.map